// extracted by mini-css-extract-plugin
export var wordContainer = "_oz-0";